import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import cookie from "react-cookies";

import queryString from "query-string";

import { moment } from "../common/common";

import { getLoggedProfile } from "../../actions/sessionAct";
import { getCarDetail } from "../../actions/carDetailAct";

import { devMode } from "../../model/base";
// import { getCarDetail } from "../../model/car";

import { commonErr } from "../common/errors";
import { stypes, formatTitleInUrl } from "../common/common";
import { LoadingPage, LoadingInline } from "../common/loading";

import ImageLightBox from "../common/imagelightbox";
import { MessagePage } from "../common/messagebox";

import Login from "../login/login";
import SignUp from "../login/signup";
import Header from "../components/header";
import Footer from "../components/footer";
import CarDetailHeader from "./components/cardetailheader";
import CarDetailCover from "./components/cardetailcover";
import RelatedCars from "./relatedcars";
import BookingSideBar from "./bookingsidebar";
import CarReport from "./carreport";
import CarReviews from "./carreviews";
import CancelPolicy from "./components/cancelpolicy";

import { IcInstant, IcPhotos, IcIns } from "../common/svg";
import {
	InfoCar,
	OutsFeatures,
	Features,
	Description,
	Papers,
	Mortgates,
	Policy,
	Owner,
	CarMap,
} from "./components/infocar";

import avatar_default from "../../static/images/avatar_default.png";

export const structuredDataSingle = (carDetail, stype) => {
	const { info, reviews } = carDetail;

	let data = {
		"@context": "http://schema.org/",
		"@type": "Product",
		name: `${info.name}`,
		image: info.photos.map((photo) => {
			return photo.thumbUrl;
		}),
		description: `${info.desc}`,
		url: `https://www.mioto.vn/car/${stype === stypes.SD ? "" : "wd/"}${formatTitleInUrl(info.name)}/${info.id}`,
		offers: {
			"@type": "Offer",
			priceCurrency: "VND",
			price: `${stype === stypes.SD ? info.price : info.wdShort ? info.wdShort.price : null}`,
			availability: "https://schema.org/InStock",
			priceValidUntil: moment().add(3, "month").format("DD/MM/YYYY"),
			url: `https://www.mioto.vn/car/${stype === stypes.SD ? "" : "wd/"}${formatTitleInUrl(info.name)}/${info.id}`,
		},
		productId: `${info.id}`,
		category: 916,
		gtin14: "",
		sku: `${info.id}`,
		googleProductCategory: 916,
		review:
			reviews && reviews.length > 0
				? reviews.map((review) => {
						return {
							"@type": "Review",
							datePublisher: `${moment(review.timeCreated)}`,
							author: { "@type": "Person", name: `` },
							reviewRating: {
								"@type": "Rating",
								bestRating: "5",
								ratingValue: `${review.rating}`,
								worstRating: "1",
							},
						};
				  })
				: [],
		aggregateRating:
			info.totalReviews > 0
				? {
						"@type": "AggregateRating",
						ratingValue: `${info.rating.avg}`,
						reviewCount: `${info.totalReviews}`,
				  }
				: [],
	};
	return JSON.stringify(data);
};

class CarDetailInfo extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			showMapBox: false,
			showSignup: false,
			showLoginForm: false,
		};

		this.stype = this.props.stype;
		this.isSD = this.props.stype === stypes.SD;
	}

	isLogged = () => {
		const { profile } = this.props.session;
		return profile && profile.info && profile.info.uid;
	};

	openLoginForm = () => {
		this.setState({
			showLoginForm: true,
		});
	};

	closeLoginForm = () => {
		this.setState({
			showLoginForm: false,
		});
	};

	openSignupForm = () => {
		this.setState({
			showSignup: true,
		});
	};

	closeSignupForm = () => {
		this.setState({
			showSignup: false,
		});
	};

	showReportForm = () => {
		this.setState({
			showReportForm: true,
		});
	};

	closeReportForm = () => {
		this.setState({
			showReportForm: false,
		});
	};

	getLoggedProfile = () => {
		this.props.dispatch(getLoggedProfile());
	};

	reportCarBtnClick = () => {
		if (!this.isLogged()) {
			this.openLoginForm();
		} else {
			this.showReportForm();
		}
	};

	updatePrice = (car) => {
		this.props.updatePrice(car);
	};

	// wd, after getprice in bookingslidebar, callback this to set stata favbuttion
	setStateFavButtonWD = (favWD) => {
		this.setState({
			favWD,
		});
	};

	openMapBox = () => {
		this.setState({
			showMapBox: true 
		})
	}

	closeMapBox = () => {
		this.setState({
			showMapBox: false 
		})
	}

	render() {
		const loggedProfile = this.props.session.profile.info;
		const { detail, deliveryId, isMCalendar } = this.props;
		const { info, profiles, relatedCars, cars } = detail;
		// const { price, priceOrigin } = info;
		// const priceSummary = (!this.isSD && detail.info.wdFull && detail.info.wdFull.priceSummary) || {};

		const relatedList = [];
		if (relatedCars && relatedCars.length > 0 && cars) {
			for (let j = 0; j < relatedCars.length; j++) {
				for (let k = 0; k < cars.length; k++) {
					if (relatedCars[j] === cars[k].id) {
						relatedList.push(cars[k]);
					}
				}
			}
		}

		var ownerProfile;
		if (profiles && profiles.length > 0) {
			for (var i = 0; i < profiles.length; ++i) {
				if (profiles[i].uid === info.ownerId) {
					ownerProfile = profiles[i];
					break;
				}
			}
		}

		return (
			<div className="detail-car">
				<div className="m-container">
					<div className="detail-container">
						<div className="content-detail">
							<InfoCar
								info={info}
								isSD={this.isSD}
								showLoginForm={this.openLoginForm}
								isLogged={this.isLogged()}
								stype={this.stype}
								favWD={this.state.favWD}
							/>
						</div>

						<BookingSideBar
							onReportCar={this.reportCarBtnClick}
							closePopup={false}
							detail={detail}
							owner={ownerProfile}
							showLoginForm={this.openLoginForm}
							loggedProfile={loggedProfile}
							updatePrice={this.updatePrice}
							stype={this.stype}
							setStateFavButtonWD={this.setStateFavButtonWD}
							deliveryId={deliveryId}
							isMCalendar={isMCalendar}
						/>

						<div className="content-detail">
							<div className="line-page" />
							<OutsFeatures info={info} />
							<div className="line-page" />

							<Description info={info} />

							<div className="line-page"></div>

							<Features info={info} />

							{info.features && info.features.length > 0 && <div className="line-page" />}

							{this.isSD && (
								<>
									<Papers info={info} />
									<Mortgates info={info} />
								</>
							)}

							<Policy policies={this.isSD ? info.notes : info.wdFull ? info.wdFull.policies : null} />

							<CancelPolicy car={true} />

							<div className="line-page"></div>

							{this.isSD && <>
								<CarMap info={info} showMapBox={this.state.showMapBox} openMapBox={this.openMapBox} closeMapBox={this.closeMapBox} />
								<div className="line-page" />
							</>}

							<Owner isSD={this.isSD} ownerProfile={ownerProfile} />

							<CarReviews detail={detail} />
						</div>
					</div>
					<div className="clear" />

					{this.isLogged() && (
						<CarReport show={this.state.showReportForm} hideModal={this.closeReportForm} car={info} />
					)}
					<Login
						show={this.state.showLoginForm}
						openSignupForm={this.openSignupForm}
						showModal={this.openLoginForm}
						hideModal={this.closeLoginForm}
						getLoggedProfile={this.getLoggedProfile}
					/>
					<SignUp
						show={this.state.showSignup}
						showModal={this.openSignupForm}
						hideModal={this.closeSignupForm}
						openLoginForm={this.openLoginForm}
						getLoggedProfile={this.getLoggedProfile}
					/>
				</div>
				{relatedList && relatedList.length > 0 && (
					<RelatedCars
						cars={relatedList}
						stype={this.stype}
						showLoginForm={this.openLoginForm}
						isLogged={this.isLogged()}
					/>
				)}
			</div>
		);
	}
}

class CarDetail extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			err: commonErr.LOADING,
			errMsg: "",
			isMCalendar: false,
		};
		this.stype = this.props.match.path === "/car/:carName/:carId" ? stypes.SD : stypes.WD;
		this.isSD = this.props.match.path === "/car/:carName/:carId" ? true : false;
	}

	componentDidMount() {
		//overide filter by query params
		if (this.props.location && this.props.location.search) {
			const query = queryString.parse(this.props.location.search);
			//GA tracking
			if (query.utm_source) {
				cookie.save("_utm_src", query.utm_source, { path: "/" });
				cookie.save("_utm_src", query.utm_source, { path: "/", domain: ".mioto.vn" });
			}
			if (query.utm_campaign) {
				cookie.save("_utm_campaign", query.utm_campaign, { path: "/" });
				cookie.save("_utm_campaign", query.utm_campaign, { path: "/", domain: ".mioto.vn" });
			}
			if (query.utm_medium) {
				cookie.save("_utm_medium", query.utm_medium, { path: "/" });
				cookie.save("_utm_medium", query.utm_medium, { path: "/", domain: ".mioto.vn" });
			}
			if (query.utm_term) {
				cookie.save("_utm_term", query.utm_term, { path: "/" });
				cookie.save("_utm_term", query.utm_term, { path: "/", domain: ".mioto.vn" });
			}
			if (query.utm_ext) {
				cookie.save("_utm_ext", query.utm_ext, { path: "/" });
				cookie.save("_utm_ext", query.utm_ext, { path: "/", domain: ".mioto.vn" });
			} else {
				cookie.remove("_utm_ext", { path: "/" });
				cookie.remove("_utm_ext", { path: "/", domain: ".mioto.vn" });
			}
		}
		const filter = this.props.carFinding.filter;

		const deliveryId =
			window.history.state !== null && window.history.state.deliveryId !== undefined
				? window.history.state.deliveryId
				: undefined;

		this.setState({
			deliveryId,
		});

		const { carId } = this.props.match.params;
		const { lat, lng } = filter;

		const ex = {
			st: filter.startDate.valueOf(),
			et: filter.endDate.valueOf(),
			carId: carId,
			lat: lat,
			lng: lng,
			deliveryId: deliveryId,
			vw: "cd",
		};

		this.getCar(ex);

		//GA
		const utmSrc = cookie.load("_utm_src") || "web_directly";
		const utmExt = cookie.load("_utm_ext") || "no_label";
		// window.ga("send", "event", utmSrc, "VIEW_CAR_DETAIL", utmExt);
		window.gtag("event", "VIEW_CAR_DETAIL", {
			event_category: utmSrc,
			event_label: utmExt,
			campaign: { source: utmSrc },
		});
		window.fbq("track", "VIEW_CAR_DETAIL");
		window.scrollTo(0, 0);
		window.addEventListener("resize", this.updateDimensions);
		this.checkWidthWindow()

	}

	// Only receive from Redux
	componentDidUpdate(prevProps) {
		if (prevProps.match.params.carId != this.props.match.params.carId) {
			const { carId } = this.props.match.params;
			const { filter } = this.props.carFinding;
			const { lat, lng } = filter;

			const ex = {
				st: filter.startDate.valueOf(),
				et: filter.endDate.valueOf(),
				carId: carId,
				lat: lat,
				lng: lng,
				deliveryId: filter.deliveryId,
				vw: "cd",
			};

			this.getCar(ex);
	
		}
	
	}

	UNSAFE_componentWillMount() {
		// Remove the default static meta description in favor of react helmets dynamic one
		if (document.querySelector("[name='description']")) {
			document.querySelector("[name='description']").remove();
		}
	}
	checkWidthWindow = () => {
		if (window.innerWidth <= 991) {
			this.setState({
				isMCalendar: true
			})
		} else {
			this.setState({
				isMCalendar: false
			})
		}
	};

	updateDimensions = () => {
		this.checkWidthWindow()
	};

	updatePrice = (data) => {
		this.setState({
			carDetail: {
				info: data.car,
				profiles: data.profiles,
				relatedCars: data.cars,
				reviews: data.reviews,
				moreReview: data.moreReview,
			},
		});
	};

	getCarDetail = (carId, lat, lng, st, et, deliveryId) => {
		this.setState({
			err: commonErr.LOADING,
		});
		getCarDetail(carId, { lat, lng, st, et, vw: "cd" }, deliveryId, this.stype).then((carDetailResp) => {
			if (carDetailResp.data.error >= commonErr.SUCCESS) {
				this.setState({
					err: carDetailResp.data.error,
					errMsg: carDetailResp.data.errorMessage,
					carDetail: {
						info: carDetailResp.data.data.car,
						profiles: carDetailResp.data.data.profiles,
						relatedCars: carDetailResp.data.data.cars,
						reviews: carDetailResp.data.data.reviews,
						moreReview: carDetailResp.data.data.moreReview,
					},
				});
			} else {
				this.setState({
					err: carDetailResp.data.error,
					errMsg: carDetailResp.data.errorMessage,
				});
			}
		});
	};

	getCar = (ex) => {
		this.setState({
			err: commonErr.LOADING,
		});
		this.props.dispatch(getCarDetail(ex)).then((resp) => {
			if (resp.action.payload.data.error === commonErr.SUCCESS) {
				this.setState({
					err: commonErr.SUCCESS,
				});
			}
		});
	};

	render() {
		const { err, deliveryId } = this.state;
		const carDetail = this.props.carDetail && this.props.carDetail.detail;

		var content;

		if (err === commonErr.LOADING) {
			content = (
				<section className="body">
					<LoadingPage />
				</section>
			);
		} else if (err >= commonErr.SUCCESS && carDetail) {
			const structuredJSON = structuredDataSingle(carDetail, this.stype);

			content = (
				<React.Fragment>
					<Helmet>
						<title>{carDetail.info.name} | MIOTO</title>
						<meta
							name="description"
							content={`Bạn đang cần thuê xe cho chuyến đi sắp tới? Đặt ngay xe ${carDetail.info.name} chỉ với giá từ ${
								this.stype === stypes.SD
									? `${carDetail.info.price}đ / ngày`
									: `${carDetail.info.wdShort ? carDetail.info.wdShort.price : "0"}đ /chuyến`
							} trên ứng dụng Mioto ngay!`}
						/>
						<meta content="Mioto" property="og:site_name" />
						<meta content={`${carDetail.info.name.toLowerCase()}`} property="og:title"></meta>
						<meta
							data-react-helmet="true"
							content={`https://www.mioto.vn/car/${this.stype === stypes.SD ? "" : "wd/"}${formatTitleInUrl(
								carDetail.info.name
							)}/${carDetail.info.id}`}
							property="og:url"
						/>
						<meta data-react-helmet="true" content={`${carDetail.info.photos[0].fullUrl}`} property="og:image"></meta>
					</Helmet>
					<section className="body">
						<CarDetailHeader stype={this.stype} />
						<CarDetailCover info={carDetail.info} stype={this.stype} />
						<CarDetailInfo
							isMCalendar={this.state.isMCalendar}
							detail={carDetail}
							updatePrice={this.updatePrice}
							stype={this.stype}
							deliveryId={deliveryId}
						/>
					</section>
					{!devMode && (
						<Helmet>
							<script type="application/ld+json">{structuredJSON}</script>
						</Helmet>
					)}
				</React.Fragment>
			);
		} else {
			content = <MessagePage message={"Không tìm thấy thông tin."} />;
		}

		return (
			<div className="mioto-layout">
				<Header notLineHeader={true} />
				{content}
				<Footer />
			</div>
		);
	}
}

function mapDetailState(state) {
	return {
		carFinding: state.carFinding,
		carDetail: state.carDetail,
	};
}

function mapSessionState(state) {
	return {
		session: state.session,
	};
}

CarDetailInfo = connect(mapSessionState)(CarDetailInfo);
CarDetail = connect(mapDetailState)(CarDetail);

export default CarDetail;
